import { restClient } from '../../client';


export type CollaborativeAgreementLicenseDetails = {
  licenseId: string;
  collaborativePhysicianMatchRequested: boolean;
};

export const getProviderCollaborativeMatchRequests = (providerId: string) => restClient.request<{
  data: CollaborativeAgreementLicenseDetails[];
}>(`/api/v1/provider/${providerId}/collaborative_match_requests`);

export const requestCollaborativePhysicianMatch = (providerId: string, licenseId: string) => restClient.request<{
  data: CollaborativeAgreementLicenseDetails;
}>(`/api/v1/provider/${providerId}/license/${licenseId}/collaborative_match_request`, {
  method: 'POST',
});
